import { type ConfigurationStorageDataV1, isConfigurationStorageDataV1 } from './ConfigurationStorageDataV1'
import type { ConfigurationStorageDataV2 } from './ConfigurationStorageDataV2'

export const upgradeStorageData = (
  data: ConfigurationStorageDataV1 | ConfigurationStorageDataV2 | undefined,
): ConfigurationStorageDataV2 | undefined => {
  if (!data) {
    return undefined
  }

  if (isConfigurationStorageDataV1(data)) {
    return {
      ...data,
      version: '0.2.0',
      history: data.history?.map(({ family, fromVariant, wasUserSelectedVariant, toVariant, conflicts, consequences, ...rest }) => ({
        ...rest,
        selections: [{ family, fromVariant, wasUserSelectedVariant, toVariant }],
        consequences: {
          ...consequences,
          additions: consequences.additions.map((x) => ({ ...x, isImportant: false })),
          changes: consequences.changes.map((x) => ({ ...x, isImportant: false })),
          removals: consequences.removals.map((x) => ({ ...x, isImportant: false })),
        },
        conflicts: conflicts.map((x) => ({ ...x, isImportant: false })),
      })),
    }
  }
  return data
}
